import { cva, type VariantProps } from 'class-variance-authority';

export const badgeIconVariants = cva(
  'inline-flex size-13 shrink-0 items-center justify-center rounded-tile',
  {
    variants: {
      tone: {
        neutral: 'bg-surface-2 text-ink',
        ok: 'bg-ok-soft text-ok-text',
        bad: 'bg-danger-soft text-danger-text',
        warn: 'bg-accent-soft text-accent-text',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export type BadgeIconVariants = VariantProps<typeof badgeIconVariants>;
